import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Row, Space, Spin, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import VendorDetailsModal from "./VendorDetailsModal";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../../Context/ClientContext";
import { useTheme } from "../../../Context/ThemeContext";
import Search from "antd/es/input/Search";
import VendorRegistrationService, {
  Vendors_Status,
} from "../../../Services/Vendor/VendorRegistrationService";
import { BusinessNatures } from "../../../Services/ClientService";
import { dayjs } from "../../../../Utilities/dayjs";

export const BusinessNature = [
  "All",
  "Manu facturer",
  "Service Provider",
  "Trader",
];
const VendorDetailsTable = () => {
  const navigate = useNavigate();
  const { currentClient } = useClient();
  const { themeData } = useTheme();
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [totalRecords, setTotalRecords] = React.useState<number>();
  const [data, setData] = React.useState<any[]>();
  const [loading, setLoading] = React.useState<boolean>();
  const [searchVal, setSearchVal] = React.useState<any>("");

  React.useEffect(() => {
    getAllVendorData();
  }, [page, pageSize, searchVal]);
  const getAllVendorData = async () => {
    setLoading(true);
    let res = await VendorRegistrationService?.getAllDetails(
      currentClient?.id,
      page,
      pageSize,
      searchVal,
      Vendors_Status?.Active
    );
    if (res?.result) {
      console.log("res", res);
      setTotalRecords(res?.result?.totalRecords);
      setData(
        res?.result?.map((d: any) => {
          return {
            vendorName: d?.vendorName,
            businessNature: BusinessNature[d?.businessNature],
            businessStart: dayjs(d?.businessStart).format("DD/MM/YYYY"),
            phone: d?.contactInformation[0]?.phone,
            email: d?.contactInformation[0]?.email,
          };
        })
      );
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const columns: ColumnsType<any> = [
    // {
    //   title: "Supplier Id",
    //   dataIndex: "supplierId",
    //   key: "supplierId",
    //   width: "10%",
    // },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
    },
    {
      title: "Business Nature",
      dataIndex: "businessNature",
      key: "businessNature",
    },
    {
      title: "Reg. Date",
      dataIndex: "businessStart",
      key: "businessStart",
    },
    {
      title: "Contact Number",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: () => (
        <>
          <Space>
            <Row>
              <Col>
                <Button
                  size="small"
                  onClick={() =>
                    navigate(
                      `/inventory/clients/${currentClient?.id}/vendor/vendorDetails`
                      // {
                      //   state:
                      // }
                    )
                  }
                >
                  <EyeOutlined />
                </Button>
              </Col>
              {/* <Col>
                <Button size="small">
                  <DeleteOutlined />
                </Button>
              </Col> */}
            </Row>
          </Space>
        </>
      ),
    },
  ];

  console.log("vall", searchVal);

  return (
    <>
      <div>
        <Card
          size="small"
          className="TableCard"
          style={{
            // marginTop: "6px",
            marginTop: 10,
            // padding: "48px 0px 0px 0px",
            boxShadow: "0px 0px 10px 0px #96A1C84D",
          }}
        >
          <Spin spinning={loading} indicator={<LoadingOutlined />}>
            <Row style={{ marginTop: "5px" }} justify={"end"}>
              <Col>
                <Search
                  onChange={(e: any) => setSearchVal(e.target.value)}
                  placeholder="Search here..."
                />
              </Col>
            </Row>
            <Table
              style={{ marginTop: "10px" }}
              columns={columns}
              className={`Tabel-style table-${
                themeData?.componentSize ?? "middle"
              }`}
              dataSource={data}
              pagination={{
                // total: totalRecords,
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                onChange: (page: number, pageSize: number) => {
                  setPage(page);
                  setPageSize(pageSize);
                },
                pageSizeOptions: ["10", "15", "25", "50", "100"],
                showTotal: (totalRecords, page) =>
                  `${page[0]}-${page[1]} of ${totalRecords} items`,
              }}        
            />
          </Spin>
        </Card>
      </div>
    </>
  );
};

export default VendorDetailsTable;
